/**
 * Copyright (c) 2022 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */

import { getDefaultDocumentSectionConfigs, getSupportContactInfoForPrincipal, renderDefaultDashboardOverview, renderDefaultProfileSidebar } from '../common';
export { getProfileTabs, getPipelinePollingInterval, getDashboardBanner } from '../common';
export const getSupportContactInfo = () => getSupportContactInfoForPrincipal('multi_tenant_tpr');
export const renderDashboardOverview = (dashboardSections, loan, documents, removeDoc, setInstructionOpen, areInstructionsOpen) => renderDefaultDashboardOverview(dashboardSections, loan, getDefaultDocumentSectionConfigs(documents, removeDoc), setInstructionOpen, areInstructionsOpen);
export const renderProfileSidebar = renderDefaultProfileSidebar;
export const getAllowedRoutes = _me => {
  return {
    allowedRoutes: ['/select-tenant'],
    defaultLandingPath: '/select-tenant'
  };
};